export default {
  switchUser: 'Switch user',

  doubleConfirmSwitch: 'Are you sure you want to switch to {{ 1 }}?'
}